import React, { useState } from "react";

export default function NewsletterSignup({ compact = false }) {
  const [status, setStatus] = useState("idle");

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);
    formData.append("form_type", "newsletter_subscription");

    try {
      const response = await fetch("https://getform.io/f/apjxxjoa", {
        method: "POST",
        body: formData,
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        throw new Error("Subscription failed");
      }

      form.reset();
      setStatus("success");
    } catch (error) {
      setStatus("error");
    }
  };

  return (
    <section className={`newsletter-signup ${compact ? "compact" : ""}`}>
      <div>
        <span className="eyebrow">Subscribe</span>
        <h2>Get new Data Apparatus articles by email.</h2>
        <p>
          Practical notes on data lineage, governance, Power BI, Microsoft Fabric, Azure
          Data Factory, SQL and modern data architecture.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="newsletter-form">
        <input type="hidden" name="subject" value="New Data Apparatus blog subscriber" />
        <label>
          Email address
          <input type="email" name="email" placeholder="you@company.com" required />
        </label>
        <button type="submit" className="primary-btn">
          Subscribe
        </button>
        {status === "success" && (
          <p className="newsletter-feedback success">
            Thanks, you are on the list.
          </p>
        )}
        {status === "error" && (
          <p className="newsletter-feedback error">
            Something went wrong. Email nurlan.alizada@dataapparatus.com.au to subscribe.
          </p>
        )}
      </form>
    </section>
  );
}
